import styled from "styled-components";

export const Container = styled.div<{ unlockOrder?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 28px 16px;
  width: 100%;
  max-width: 285px;
  background: linear-gradient(45deg, #E5E7EB, #FFFFFF);
  border: 2px dashed #D2D5DA;
  border-radius: 12px;
  position: relative;
  flex-shrink: 0;

  @media(min-width: 768px){
    max-width: 400px;
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`


export const Padlock = styled.div`
  width: 80px;
  height: 80px;
  background-color: #D9D9D9;
  border-radius: 80px;
  display: flex;
  align-items:center;
  justify-content: center;
  font-size: 52px;
`
export const Title = styled.h3`
  margin: 0px;
  font-size: 24px;
  font-weight: 500;
  text-wrap: wrap;
  line-height: normal;
`
export const Subtitle = styled.p`
  margin: 0px;
  font-size: 14px;
  font-weight: 500;
  text-wrap: wrap;
  line-height: normal;
`